import { render, staticRenderFns } from "./EventAbsenceChip.vue?vue&type=template&id=102bcc11"
import script from "./EventAbsenceChip.vue?vue&type=script&lang=js"
export * from "./EventAbsenceChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports